import { IconName } from 'ui/components'
import { IconButton } from 'ui/components/Buttons'
import { useConfirmation } from 'ui/hooks'
import { Col, FormRow } from 'ui/themes/globalStyles'

import { Value } from './fields'

type MarketWhereTradedProps = {
  index: number
  rowsNumber: number
  onDelete: (index: number) => void
}

export const CUSIPNumber = ({ index, rowsNumber, onDelete }: MarketWhereTradedProps) => {
  const { open: startDeleting, Confirmation } = useConfirmation({
    message: `Are you sure you want to remove this item?`,
    onConfirm: () => onDelete(index),
    confirmationButtonText: 'Delete',
    isConfirmationNegative: true
  })

  return (
    <>
      <Confirmation />
      <FormRow>
        <Col>
          <Value index={index} />
        </Col>
      </FormRow>
      {rowsNumber > 1 && (
        <FormRow>
          <IconButton face="negative" icon={IconName.DELETE} onClick={startDeleting} />
        </FormRow>
      )}
    </>
  )
}
